import React from "react";
import Accordion from "./Accordion";
import SelectCovers from "./SelectCovers";
import _ from "lodash";

const SelectCoverByCoverType = ({
  coverType,
  locations,
  selectedCovers = {},
  nodestate,
  ...rest
}) => {
  const config = {
    LOCATION: {
      byLocation: true,
    },
  };

  const coverConfig = config[coverType] || {};

  // Create a list of all items for the Accordion
  const items = [];

  console.log("Dream Derom on dream onn", selectedCovers);

  if (!_.isEmpty(selectedCovers)) {
    locations.forEach((location) => {
      const locationId = location.id;
      const locationSelectedCovers = selectedCovers?.location[locationId];
      const buildingKeys = Object.keys(selectedCovers?.location).filter((key) =>
        key.startsWith(`${locationId}_building_`)
      );
      if (buildingKeys.length > 0) {
        // If there are buildings, process each building
        buildingKeys.forEach((buildingKey) => {
          const buildingSelectedCovers = selectedCovers.location[buildingKey];
          const buildingName =
            nodestate[
              `location_${locationId}_building_${buildingKey
                .split("_")
                .pop()}_59000a`
            ]?.answer;
          items.push({
            component: (
              <SelectCovers
                location={location}
                building={buildingKey.split("_").pop()}
                selectedCovers={buildingSelectedCovers}
                {...rest}
              />
            ),
            title: buildingName
              ? buildingName
              : `Location ${locationId} - ${location.address?.streetNumber}, ${
                  location.address.town
                } - ${location.address.postalcode} - Property ${
                  parseInt(buildingKey.split("_").pop()) + 1
                }`,
            location: location,
          });
        });
      } else if (locationSelectedCovers) {
        // If no buildings, process the location
        items.push({
          component: (
            <SelectCovers
              location={location}
              selectedCovers={locationSelectedCovers}
              {...rest}
            />
          ),
          title: `${location.address?.streetNumber}, ${location.address.town} - ${location.address.postalcode}`,
          location: location,
        });
      }
    });
  }

  return (
    <>
      {coverConfig.byLocation && <Accordion items={items} />}

      {!coverConfig.byLocation && (
        <SelectCovers selectedCovers={selectedCovers} {...rest} />
      )}
    </>
  );
};

export default SelectCoverByCoverType;
